export function getAuthCodes(): {code:string, codeVerifier:string} {
  const params = new URLSearchParams(new URL(window.location.href).search);
  const code = params.get('code') as string;
  const state = params.get('state') as string;
  const stateCodeVerifier = localStorage.getItem(`pkce.${state}`) || '';

  return { code, codeVerifier: stateCodeVerifier };
}
